import React, { useContext, useState, useRef } from 'react';
import styles from './tab-orders.module.scss';
import {formatDateTime, toCurrency} from "../../../../../helpr/helper";
import {Button, Col, Pagination, Row, Table} from "react-bootstrap";
import {
  REDUCER_ACTION_CHECK,
  REDUCER_ACTION_CHECK_ALL,
  SecurityContext,
  SecurityDispatchContext
} from "../../../../../context/security-context";
import detailsArrowIcon from "../../../../../assets/table-details-arrow.svg";
import paginationLeftIcon from '../../../../../assets/pagination-arrow-left.svg';
import paginationRightIcon from '../../../../../assets/pagination-arrow-right.svg';
import pendingIcon from '../../../../../assets/orders-table-pending.svg';
import acceptIcon from '../../../../../assets/orders-table-accept.svg';
import rejectIcon from '../../../../../assets/orders-table-reject.svg';

import usePagination from "../../../../../hooks/use-pagination";
import FilterOrder from "../filter-order/filter-order";
import ModalCustom from "../../../../../components/modal/modal";
import OrderSummaryModalContent from "../modal-content-order-summary/modal-content-order-summary";
import BulkOrderAcceptModalContent from "../modal-content-order-bulk-accept/modal-content-order-bulk-accept";
import BulkOrderRejectModalContent from "../modal-content-order-bulk-reject/modal-content-order-bulk-reject";
import {ORDER_ACCEPTED, ORDER_REJECTED} from "../../../../../helpr/constants";

const OrdersTab = () => {
  //Checkbox related states
  const [ allCheckboxState, setAllCheckboxState ] = useState(false);
  //Order reference for order summary
  const [modalState, setModalState] = useState({
    title: '',
    show: false,
    component: '',
    style: ''
  });
  const clickOrderSummary = useRef({});
  //Get orders from context
  const { ordersState, securityState } = useContext(SecurityContext);
  const { ordersDispatch } = useContext(SecurityDispatchContext);
  //Define order table headers
  const headers = [{ key: 'refNumber', value: 'Ref Number', filter: false, class: '' },
    { key: 'applicantName', value: 'Primary Applicant', filter: true, class:'' },
    { key: '', value: 'Amount', filter: false, class: 'right-aligned' },
    { key: '', value: 'Reservation Date', filter: false, class: '' },
    { key: '', value: 'Upload', filter: false, class: '' },
    { key: '', value: 'Status', filter: false, class: ''}, { value: '', filter: false, class: '' }];
  //Page data
  const pagedData = usePagination(ordersState.filtered,100);
  const pages = Array(pagedData.maxPage).fill().map((_, i) =>
      <Pagination.Item
        key={i+1}
        active={(i+1) === pagedData.currentPage}
        onClick={() => pagedData.jump(i+1)}>
        {i+1}
      </Pagination.Item>);
  //Checkbox functions
  const onAllCheckboxChange = e => {
    const state = !allCheckboxState;
    ordersDispatch({
      type: REDUCER_ACTION_CHECK_ALL,
      previous: ordersState,
      data: state
    });
    setAllCheckboxState(state);
  }
  const onCheckboxChange = e => {
    const { name } = e.target;
    ordersDispatch({
      type: REDUCER_ACTION_CHECK,
      previous: ordersState,
      data: name
    });
  }
  const countChecked = () => {
    return ordersState.filtered.filter(o => o.checked && o.orderStatus === '0').length;
  }

  //Modal actions
  const closeModal = () => {
    setModalState(prev => ({
      ...modalState,
      show: false,
      component: '',
      style: prev.style
    }));
  }
  const showOrderSummary = (order) => {
    clickOrderSummary.current = order;
    const component = <OrderSummaryModalContent order={clickOrderSummary.current} onClose={() => closeModal()} modalConfig={{setModalState}}/>
    setModalState({
      ...modalState,
      title: "Reservation Summary",
      show: true,
      component: component,
      style: styles['order-summary-modal']
    });
  }
  const showBulkAccept = () => {
    const component = <BulkOrderAcceptModalContent onClose={() => closeModal()} modalConfig={{setModalState}} />
    setModalState({
      ...modalState,
      title: "Bulk Reservation Confirmation",
      show: true,
      component: component,
      style: `${styles['bulk-accept-order-modal']} ${styles['confirm-modal']}`
    });
  }
  const showBulkReject = () => {
    const component = <BulkOrderRejectModalContent onClose={() => closeModal()} modalConfig={{setModalState}} />
    setModalState({
      ...modalState,
      title: "Bulk Reservation Rejection",
      show: true,
      component: component,
      style: `${styles['bulk-reject-order-modal']} ${styles['confirm-modal']}`
    });
  }

  return (
    <div className={styles['orders']}>
      <div className={styles['filter']}>
        <Row>
          {countChecked() > 0
            ? (
              <>
                <Col className={styles['filter-actions']} xs={{ span: 6, order: 3 }} lg={{ span: 2, order: 1}}>
                  <Button onClick={() => showBulkAccept()} size="sm">ACCEPT</Button>
                </Col>
                <Col className={styles['filter-actions']} xs={{ span: 6, order: 4 }} lg={{ span: 2, order: 2}}>
                  <Button onClick={() => showBulkReject()} size="sm" variant="danger">REJECT</Button>
                </Col>
              </>
            ) : <><Col lg={2}></Col><Col lg={2}></Col></>
          }
          <FilterOrder headers={headers} setPage={pagedData.jump} />
        </Row>
      </div>
      <div className={styles['header']}>
        {countChecked() > 0 ? `${countChecked()} selected` : ''}
      </div>
      <Table responsive>
        <thead>
        <tr>
          <th>{securityState.securityStatus === '0'
            ? renderCheckbox('allCheckbox', allCheckboxState, onAllCheckboxChange) : ''}</th>
          {headers.map((header, index) =>
            <th className={styles[header['class']]} key={index}>{header.value}</th>)}
        </tr>
        </thead>
        <tbody>
        {pagedData.currentData().map((order, index) => {
          return (
            <tr key={index}>
              <td>{order.orderStatus === '0' && securityState.securityStatus === '0'
                ? renderCheckbox(order.orderId, order.checked, onCheckboxChange) : ''}</td>
              <td>{order.refNumber}</td>
              <td>{order.primaryApplicant}</td>
              <td className={styles['right-aligned']}>{`PHP ${toCurrency(order.scaledAmount)}`}</td>
              <td>{formatDateTime(order.createdDate)}</td>
              <td>{order.generatedFromFileUpload ? 'Yes' : 'No'}</td>
              <td>{renderStatus(order.orderStatus)}</td>
              <td className={styles['detail-arrow']} onClick={()=>showOrderSummary(order)}><img alt="See Details" src={detailsArrowIcon} /></td>
            </tr>
          )
        })}
        </tbody>
      </Table>
      {
        pagedData.maxPage > 0
          ? <Pagination>
            <Pagination.First
              onClick={() => pagedData.jump(1)}
              disabled={pagedData.currentPage === 1}>
              <img alt="FIRST" src={paginationLeftIcon}/>
            </Pagination.First>
            <Pagination.Prev
              onClick={() => pagedData.jump(pagedData.currentPage - 1)}
              disabled={pagedData.currentPage === 1}>
              PREV
            </Pagination.Prev>
            {pages}
            <Pagination.Next
              onClick={() => pagedData.jump(pagedData.currentPage + 1)}
              disabled={pagedData.currentPage === pagedData.maxPage}>
              NEXT
            </Pagination.Next>
            <Pagination.Last
              onClick={() => pagedData.jump(pagedData.maxPage)}
              disabled={pagedData.currentPage === pagedData.maxPage}>
              <img alt="LAST" src={paginationRightIcon}/>
            </Pagination.Last>
          </Pagination> :
          <div className={styles['no-data']}>No reservations to display.</div>
      }
      <ModalCustom
        show={modalState.show}
        title={modalState.title}
        onClose={() => closeModal()}
        component={modalState.component}
        style={modalState.style ? modalState.style : ''} />
    </div>
  )
}

const renderStatus = (status) => {
  switch(status){
    case ORDER_ACCEPTED:
      return <span><img alt="Accepted" src={acceptIcon}/>  Accepted</span>
    case ORDER_REJECTED:
      return <span><img alt="Rejected" src={rejectIcon}/>  Rejected</span>
    default:
      return <span><img alt="Pending" src={pendingIcon}/>  Pending</span>
  }
}

const renderCheckbox = (name, isChecked, onChange) => {
  return <input
    className={styles['checkbox']}
    id={name}
    name={name}
    checked={isChecked}
    onChange={onChange}
    type="checkbox" />
}

export default OrdersTab;
